var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"goods-change"},[_c('goods-top-menu'),_c('b-container',{staticClass:"mb-5",attrs:{"fluid":""}},[_c('MassChangeBrand')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }